import React__default, { createContext, useMemo, useState, Children, cloneElement, createElement, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var makeId = function makeId() {
  return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
};

var TabsOuter = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: black;\n  ", "\n"], ["\n  color: black;\n  ", "\n"])), function (props) {
  return props.verticalLayout && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    & .tabs__content {\n      flex: 1;\n    }\n  "], ["\n    display: flex;\n    & .tabs__content {\n      flex: 1;\n    }\n  "])));
});
var TabsInner = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  & > .tab:first-of-type {\n    border-top-left-radius: 3px;\n  }\n  & > .tab:last-of-type {\n    ", "\n  }\n  ", "\n  ", "\n"], ["\n  display: flex;\n  position: relative;\n  & > .tab:first-of-type {\n    border-top-left-radius: 3px;\n  }\n  & > .tab:last-of-type {\n    ", "\n  }\n  ", "\n  ", "\n"])), function (props) {
  return props.verticalLayout ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-bottom-left-radius: 3px;\n    "], ["\n      border-bottom-left-radius: 3px;\n    "]))) : css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border-top-right-radius: 3px;\n    "], ["\n      border-top-right-radius: 3px;\n    "])));
}, function (props) {
  return props.stretchTabsTitle && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    & > .tab {\n      flex: 1;\n    }\n  "], ["\n    & > .tab {\n      flex: 1;\n    }\n  "])));
}, function (props) {
  return props.verticalLayout && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-direction: column;\n  "], ["\n    flex-direction: column;\n  "])));
});
var TabsContent = styled.div.attrs({
  className: 'tabs__content'
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 20px;\n  background: whitesmoke;\n  border-bottom-right-radius: 3px;\n  ", ";\n  ", ";\n  box-shadow: 0 6px 30px rgba(0,0,0,0.14);\n  overflow: hidden;\n"], ["\n  padding: 20px;\n  background: whitesmoke;\n  border-bottom-right-radius: 3px;\n  ", ";\n  ", ";\n  box-shadow: 0 6px 30px rgba(0,0,0,0.14);\n  overflow: hidden;\n"])), function (props) {
  return !props.stretchTabsTitle && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    border-top-right-radius: 3px;\n  "], ["\n    border-top-right-radius: 3px;\n  "])));
}, function (props) {
  return !props.verticalLayout && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    border-bottom-left-radius: 3px;\n  "], ["\n    border-bottom-left-radius: 3px;\n  "])));
});
var TabsContext = createContext({
  selectedTabIndex: 0
});

var Tabs = function Tabs(_a) {
  var children = _a.children,
      initialTabIndex = _a.initialTabIndex,
      stretchTabsTitle = _a.stretchTabsTitle,
      initial = _a.initial,
      exit = _a.exit,
      animate = _a.animate,
      verticalLayout = _a.verticalLayout,
      rest = __rest(_a, ["children", "initialTabIndex", "stretchTabsTitle", "initial", "exit", "animate", "verticalLayout"]);

  var id = useMemo(function () {
    return makeId();
  }, []);

  var _b = useState(initialTabIndex),
      selectedTabIndex = _b[0],
      setSelectedTabIndex = _b[1];

  var elements = useMemo(function () {
    return Children.toArray(children).map(function (el, index) {
      return cloneElement(el, _assign({}, el.props, {
        isActive: selectedTabIndex === index,
        onClick: function onClick() {
          setSelectedTabIndex(index);
        },
        initial: initial,
        exit: exit,
        id: id,
        animate: animate
      }));
    });
  }, [children, selectedTabIndex]);
  return createElement(TabsContext.Provider, {
    value: {
      selectedTabIndex: selectedTabIndex
    }
  }, createElement(TabsOuter, _assign({
    verticalLayout: verticalLayout
  }, rest), createElement(TabsInner, {
    verticalLayout: verticalLayout,
    stretchTabsTitle: stretchTabsTitle
  }, elements), createElement(TabsContent, {
    id: id,
    verticalLayout: verticalLayout,
    stretchTabsTitle: stretchTabsTitle
  })));
};

Tabs.defaultProps = {
  stretchTabsTitle: false,
  verticalLayout: false,
  initialTabIndex: 0,
  initial: {
    opacity: 0,
    x: 40
  },
  animate: {
    opacity: 1,
    x: 0
  },
  exit: {
    opacity: 0,
    x: 40
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
var ContentInner = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));

var Content = function Content(_a) {
  var children = _a.children,
      isActive = _a.isActive,
      initial = _a.initial,
      id = _a.id,
      animate = _a.animate,
      exit = _a.exit;
  var portal = React__default.useRef();

  var _b = useState(false),
      shouldDisplay = _b[0],
      setShouldDisplay = _b[1];

  useEffect(function () {
    portal.current = document.querySelector(".tabs__content#" + id) || undefined;
    setShouldDisplay(true);
  }, []);

  if (!shouldDisplay) {
    return null;
  }

  return isActive && portal.current ? createPortal(React__default.createElement(AnimatePresence, null, React__default.createElement(motion.div, {
    initial: initial,
    animate: animate,
    exit: exit
  }, children)), portal.current) : React__default.createElement(ContentInner, null, children);
};

var templateObject_1$1;
var TitleInner = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  padding: 10px;\n  border-radius: inherit;\n  cursor: pointer;\n  height: 100%;\n  transition: all 0.15s;\n  background: whitesmoke;\n  &:hover {\n    opacity: 0.8;\n  }\n"], ["\n  padding: 10px;\n  border-radius: inherit;\n  cursor: pointer;\n  height: 100%;\n  transition: all 0.15s;\n  background: whitesmoke;\n  &:hover {\n    opacity: 0.8;\n  }\n"])));

var Title = function Title(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return React__default.createElement(TitleInner, _assign({}, rest), children);
};

var templateObject_1$2;
var TabInner = styled.div.attrs({
  className: 'tab'
})(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n"], ["\n  ", ";\n  display: flex;\n  flex-direction: column;\n"])), function (props) {
  return props.isActive ? 'opacity: 1;' : 'opacity: 0.5;';
});

var Tab = function Tab(_a) {
  var children = _a.children,
      isActive = _a.isActive,
      id = _a.id,
      onClick = _a.onClick,
      animate = _a.animate,
      exit = _a.exit,
      initial = _a.initial,
      rest = __rest(_a, ["children", "isActive", "id", "onClick", "animate", "exit", "initial"]);

  var elements = useMemo(function () {
    return Children.toArray(children).map(function (el) {
      return cloneElement(el, _assign({}, el.props, {
        animate: animate,
        exit: exit,
        id: id,
        initial: initial,
        isActive: isActive
      }));
    });
  }, [children, isActive]);
  return createElement(TabInner, _assign({}, rest, {
    isActive: isActive,
    onClick: onClick
  }), elements);
};

Tab.defaultProps = {
  isActive: false
};
Tab.Content = Content;
Tab.Title = Title;
var templateObject_1$3;
export { Tabs, Tab };